"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminManagementFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.adminManagementFactory = Factory.Sync.makeFactory({
    admin_invite_id: Factory.each(i => i + 1),
    email_address: Mocks.persona.email,
    phone_number: Mocks.persona.phone,
    compliance_access: true,
    financials_access: true,
    financials_access_partial: false,
    first_name: Mocks.persona.first_name,
    governing_season_admin_access: false,
    governing_season_view_access: false,
    hq_tools_access: true,
    hq_tools_access_partial: false,
    last_name: Mocks.persona.last_name,
    manage_admin_access: true,
    permission_type: 'Full Access',
    persona_id: Mocks.persona.id,
    positions: ['President'],
    profile_image_url: 'https://profile.png.test',
    super_reg_access: false,
    user_id: 1,
    website_access: true,
    website_access_partial: false,
});
